module.exports = __webpack_public_path__ + "static/media/hero-background-new-3cdf6f.57b15568.png";